/* global sr */

import Vue from 'vue';
import $ from 'jquery';
import VueShave from 'vue-shave';
import { VueMasonryPlugin } from 'babel-loader!vue-masonry';
import VueBgSrc from 'vue-bg-src';

import { i18n } from '../translation.js';
import QdTabs from './tabs/tabs.js';
import QdTabsContent from './tabs-content/tabs-content.js';
import QdTabContent from './tab-content/tab-content.js';
import QdSocialfeedSlider from './socialfeed-slider/socialfeed-slider.js';
import QdNewsSocial from './news-social/news-social.js';
import QdFilter from './filter/filter.js';
import QdDealers from './dealers/dealers.js';
import QdOpenPopup from './open-popup/open-popup.js';
import QdDealerPopup from './dealer-popup/dealer-popup.js';
import QdGoogleMap from './google-map/google-map.js';
import QdSlider from './slider/slider.js';
import QdSlotInputSlider from './slot-input-slider/slot-input-slider.js';
import QdCardView from './card-view/card-view.js';
import QdSlideSelector from './slide-selector/slide-selector.js';
import QdSearch from './search/search.js';
import QdGoogleAutocomplete from './google-autocomplete/google-autocomplete.js';
import VueVideoSection from 'vue-video-section'

// Initialize siteData variable on window
window.siteData = window.siteData || {};

// Add site-wide data here:
const siteData = Object.assign(
	window.siteData,
	{
		qdIsActive: false,
		qdPopup: null,
		qdDealersCordinates: null,
		qdIsNavOpen: false,
		qdScrollPosition: 0,
		qdHasStickyNav: false,
		qdShowStickyNav: false,
		qdHideElements: false,
		qdSignupSubmitStatus: '',
		isMounted: false,
		qdDealersFilterSelections: {},
		qdNoDealers: 'default',
		showBanner: true,
		mountVideo: false
	}
);

i18n.locale = siteData.language;

siteData.langClass = 'lang-' + siteData.language;

Vue.use(VueMasonryPlugin);
Vue.use(VueShave);

const mediaQueries = {
	sm: '(min-width: 374px) and (max-width: 766)',
	md: '(min-width: 767px) and (max-width: 1199)',
	lg: '(min-width: 1200px)',
};

Vue.use(VueBgSrc, { mediaQueries: mediaQueries });

export default new Vue({
	el: '#root',
	data: siteData,
	components: {
		QdTabsContent,
		QdTabContent,
		QdTabs,
		QdFilter,
		QdDealers,
		QdOpenPopup,
		QdDealerPopup,
		QdGoogleMap,
		QdSlider,
		QdSlotInputSlider,
		QdCardView,
		QdSocialfeedSlider,
		QdNewsSocial,
		QdSlideSelector,
		QdSearch,
		QdGoogleAutocomplete,
		VueVideoSection
	},
	computed: {
		noDealersInArea() {
			const mail = this.contactMail;
			return this.$t('noDealersInArea') + ` <a href="mailto:${mail}">${mail}</a>`;
		},
		noProductLinesInArea() {
			const mail = this.contactMail;
			return this.$t('noProductLinesInArea') + ` <a href="mailto:${mail}">${mail}</a>`;
		},
	},
	watch: {
		qdPopup() {
			const scope = this;
			if (this.qdPopup !== null) {
				$.magnificPopup.open({
					items: {
						src: scope.qdPopup.type,
					},
					type: 'inline',
					callbacks: {
						close() {
							scope.qdPopup = null;
						},
					},

					// You may add options here, they're exactly the same as for $.fn.magnificPopup call
					// Note that some settings that rely on click event (like disableOn or midClick) will not work here
				}, 0);
			}
		},
		qdDealersCordinates() {
			const productline = this.qdDealersFilterSelections.hasOwnProperty('product_lines_picker_id') && this.qdDealersFilterSelections.product_lines_picker_id.length > 0 ? true : false;
			if (this.qdDealersCordinates.length < 1 && productline) {
				this.qdNoDealers = 'productline';
			} else if (this.qdDealersCordinates.length < 1) {
				this.qdNoDealers = 'area';
			} else {
				this.qdNoDealers = 'default';
			}
		},
	},
	methods: {
		updateData(name, value) {
			if (process.env.NODE_ENV !== 'production') {
				console.log(name, value);
			}
			siteData[name] = value;
		},
		setActive() {
			siteData.qdIsActive = !siteData.qdIsActive;
		},
		toggleNav() {
			siteData.qdIsNavOpen = !siteData.qdIsNavOpen;
		},
		focusSearch(id) {
			siteData.qdIsNavOpen = true;
			setTimeout(() => {
				document.getElementById(id).focus();
			}, 500);
		},
		onScroll() {
			const currentScrollPosition = window.scrollY;
			siteData.qdHasStickyNav = currentScrollPosition > 500;
			siteData.qdShowStickyNav = currentScrollPosition < siteData.qdScrollPosition && currentScrollPosition !== 0 && !siteData.qdPopup;
			siteData.qdScrollPosition = currentScrollPosition;
		},
	},
	i18n: i18n,
	created() {
		window.addEventListener('scroll', this.onScroll);
		$('.qd-hidden', this.$el).removeClass('qd-hidden');
	},
	mounted() {
		setTimeout(() => {
			sr.reveal('.js-scroll-reveal', {
				easing: 'cubic-bezier( .395, .325, .365, .995 )',
				viewFactor: 0.2,
			});
			sr.reveal('.js-scroll-reveal--static', {
				distance: 0,
				scale: 0,
			});
		}, 200);

		this.$nextTick(function () {
			this.mountVideo = true

			window.addEventListener('load', () => {
				let player = this.$refs['header-background-video'];

				if (player) {
					this.$refs['header-background-video'].playVideo().then(() => {

						this.$nextTick(function () {
							this.showBanner = false
						})

					}
					)
				}
			})
		})
	},
	destroyed() {
		window.removeEventListener('scroll', this.onScroll);
	},
});



// WEBPACK FOOTER //
// ./assets/_js/components/root.js